module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-container"
  }, [_c('header', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "formbox"
  }, [_c('div', {
    staticClass: "order-tit"
  }, [_vm._v("三叶儿童口腔-快速预约")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ul', [_c('li', [_c('label', {
    attrs: {
      "for": "J_Name"
    }
  }, [_vm._v("患者姓名：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.patientname),
      expression: "user.patientname"
    }],
    attrs: {
      "type": "text",
      "id": "J_Name",
      "maxlength": "15",
      "placeholder": "用于就诊信息调用,务必正确填写"
    },
    domProps: {
      "value": (_vm.user.patientname)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.patientname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_Tel"
    }
  }, [_vm._v("联系方式：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.myInfo.tel),
      expression: "myInfo.tel"
    }],
    attrs: {
      "type": "text",
      "id": "J_Tel",
      "readonly": "",
      "onfocus": "javascript:this.blur();"
    },
    domProps: {
      "value": (_vm.myInfo.tel)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.myInfo.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_Age"
    }
  }, [_vm._v("患者年龄：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.age),
      expression: "user.age"
    }],
    attrs: {
      "type": "text",
      "id": "J_Age",
      "maxlength": "3",
      "placeholder": "请填写年龄，1岁以下填写为1"
    },
    domProps: {
      "value": (_vm.user.age)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('age')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.age = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('label', [_vm._v("期望医院：")]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "J_HospitalList"
    }
  }, _vm._l((_vm.hospitalItems), function(item) {
    return _c('option', {
      domProps: {
        "value": item.hospitalid
      }
    }, [_vm._v(_vm._s(item.hospitalname))])
  })), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', [_c('label', [_vm._v("病症选择：")]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "J_DiseaseList"
    }
  }, _vm._l((_vm.diseaseItems), function(item) {
    return _c('option', {
      domProps: {
        "value": item.diseaseid
      }
    }, [_vm._v(_vm._s(item.diseasename))])
  })), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', [_c('label', [_vm._v("备　　注：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.remark),
      expression: "user.remark"
    }],
    attrs: {
      "id": "J_Remark",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.user.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.remark = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('DownloadApp'), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  }), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', [_vm._v("就医时间：")]), _c('input', {
    attrs: {
      "type": "text",
      "id": "J_Date",
      "value": "",
      "placeholder": "请选择就医时间",
      "readonly": "",
      "onfocus": "javascript:this.blur();"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('img', {
    attrs: {
      "src": require("../assets/arrow_down.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('img', {
    attrs: {
      "src": require("../assets/arrow_down.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "btn"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "id": "J_OrderBtn",
      "value": "预约"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7ce06242"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderSanye.vue
// module id = 199
// module chunks = 1